(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feliora-dog-content"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('feliora-dog-section')){customElements.define('feliora-dog-section',class extends HTMLElement{connectedCallback(){this.abort?.abort();this.observer?.disconnect();this.abort=new AbortController();const signal=this.abort.signal,track=this.querySelector('[data-fd-track]'),controls=this.querySelector('[data-fd-controls]');if(track&&controls){const update=()=>{controls.hidden=track.scrollWidth<=track.clientWidth+4;this.querySelector('[data-fd-prev]').disabled=track.scrollLeft<=1;this.querySelector('[data-fd-next]').disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};for(const[selector,direction]of[['[data-fd-prev]',-1],['[data-fd-next]',1]]){this.querySelector(selector).addEventListener('click',()=>{const card=track.querySelector('[data-fd-card]');if(card)track.scrollBy({left:direction*(card.getBoundingClientRect().width+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})},{signal})}track.addEventListener('scroll',update,{signal,passive:true});this.observer=new ResizeObserver(update);this.observer.observe(track);update()}for(const video of this.querySelectorAll('video'))video.addEventListener('play',()=>{for(const other of document.querySelectorAll('feliora-dog-section video'))if(other!==video)other.pause()},{signal});const search=this.querySelector('[data-fd-search]');if(search&&track){const cards=Array.from(track.querySelectorAll('[data-fd-card]'));const filter=()=>{const query=search.value.toLocaleLowerCase('pl'),photoOnly=this.querySelector('[data-fd-photos]').checked;let count=0;for(const card of cards){card.hidden=!card.textContent.toLocaleLowerCase('pl').includes(query)||(photoOnly&&card.dataset.photo!=='true');if(!card.hidden)count++}this.querySelector('[data-fd-empty]').hidden=count>0};search.addEventListener('input',filter,{signal});this.querySelector('[data-fd-photos]').addEventListener('change',filter,{signal});this.querySelector('[data-fd-sort]').addEventListener('change',event=>{const sorted=event.target.value==='rating'?[...cards].sort((a,b)=>Number(b.dataset.rating)-Number(a.dataset.rating)):cards;for(const card of sorted)track.append(card)},{signal})}}disconnectedCallback(){this.abort?.abort();this.observer?.disconnect()}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
